<template>
  <div id="app" :class="[$route.path.indexOf('/guide') === -1 ?  'padding-top' : '']">
    <official-head v-if="$route.path.indexOf('/guide') === -1"></official-head>
    <keep-alive>
      <router-view v-if="!$route.meta.noCache" class="router-view"></router-view>
    </keep-alive>
    <router-view v-if="$route.meta.noCache" class="router-view"></router-view>
	<!-- <router-view></router-view> -->
    <official-foot></official-foot>
  </div>
</template>

<script>
import officialHead from '@/components/officialHead';
import officialFoot from '@/components/officialFoot';
export default {
	components: { officialHead, officialFoot },
	name: 'App'
};
</script>

<style>
.router-view{
	min-height: calc(100vh - 302px);
}
#app {
	position: relative;
	min-height: 100%;
	/*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.padding-top {
	padding-top: 60px;
}

.pb50 {
	padding-bottom: 50px;
}

.pt20 {
	padding-top: 20px;
}
.pt30 {
	padding-top: 30px;
}

.mb10 {
	margin-bottom: 10px;
}

.mb20 {
	margin-bottom: 20px;
}

.mb30 {
	margin-bottom: 30px;
}

.mt10 {
	margin-top: 10px;
}

.mt20 {
	margin-top: 20px;
}

.mt30 {
	margin-top: 30px;
}
.mt40 {
	margin-top: 40px;
}

.plan {
	width: 1142px;
	margin-left: auto;
	margin-right: auto;
}

.fixed {
	position: fixed;
	top: 0px;
	left: 0;
	right: 0;
}

.pointer {
	cursor: pointer;
}

.pr {
	position: relative;
}

.tac {
	text-align: center;
}

.w1152 {
	width: 1152px;
	margin: 0 auto;
}

.page-t {
	font-size: 22px;
	line-height: 60px;
}

.bt {
	display: inline-block;
	padding: 8px 20px;
	margin-top: 40px;
	font-size:18px;
	color:rgba(62,204,246,1); 
	border: 2px solid rgba(24,220,255,1);
	border-radius: 21px;
}



</style>
